// extracted by mini-css-extract-plugin
module.exports = {"unsupported":"style_unsupported__OHe9h"};